import Card from "../../../../components/card/card";
import Tabs from "../../../../components/tabs/tabs";
import { useBroadcastPortalContext } from "../../broadcast-portal.context";
import type { TabIds } from "../../broadcast-portal.types";
import FormationsModule from "../formations-module/formations-module";
import { useTeamsModule } from "../teams-module/use-teams-module";
import SubsList from "./components/subs-list/subs-list";
import * as CSS from "./subs-module.styles";

const SubsModule = () => {
	const {
		homeTeam,
		awayTeam,
		lineups,
		substitutions,
		cards,
		goalScorers,
		fixtureId,
	} = useTeamsModule();

	const { activeTeam, setActiveTeam } = useBroadcastPortalContext();

	const Subs = () => (
		<>
			<div style={{ marginBottom: "1rem" }}>
				<Tabs
					activeTab={activeTeam}
					onChange={(id) => setActiveTeam(id as TabIds)}
					items={[
						{ id: "homeTeam", label: homeTeam || "Home" },
						{ id: "awayTeam", label: awayTeam || "Away" },
					]}
				/>
			</div>
			{lineups && activeTeam === "homeTeam" && (
				<SubsList
					substitutes={lineups.home.substitutes}
					subbedPlayers={substitutions.filter((s) => s.team === "home")}
					cards={cards.filter((c) => c.team === "home")}
					scorers={goalScorers}
				/>
			)}
			{lineups && activeTeam === "awayTeam" && (
				<SubsList
					substitutes={lineups.away.substitutes}
					subbedPlayers={substitutions.filter((s) => s.team === "away")}
					cards={cards.filter((c) => c.team === "away")}
					scorers={goalScorers}
				/>
			)}
		</>
	);

	return (
		<CSS.SubsModule>
			<Card
				pages={[
					{
						id: "formations",
						title: "Formations",
						children: (
							<FormationsModule
								fixtureId={fixtureId}
								activeTeam={activeTeam}
								homeTeam={homeTeam}
								awayTeam={awayTeam}
								withPadding={false}
							/>
						),
					},
					{
						id: "subs",
						title: "Substitutions",
						children: <Subs />,
					},
				]}
			></Card>
		</CSS.SubsModule>
	);
};

export default SubsModule;
